import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Logo } from '@/components/ui/brand-logo';

export function AuthLayout({
  title,
  children,
  steps,
}: {
  title: ReactNode;
  children: ReactNode;
  steps?: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-page p-4">
      <div className="flex flex-col items-center gap-2 text-center">
        <Logo size={48} />
        <h1 className="text-xl font-semibold tracking-tight">Mandistry</h1>
        <p className="text-sm text-muted">{t('auth.tagline')}</p>
      </div>
      <div className="w-full max-w-md overflow-hidden rounded-2xl border border-border bg-bg shadow-soft">
        <div className="flex h-12 items-center gap-3 border-b border-border px-5">
          <span className="flex-1 text-sm font-medium">{title}</span>
          {steps}
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
